export default __webpack_public_path__ + "static/media/Broker-Application-Form.4d41ed54.pdf";